<router-outlet></router-outlet>
<!--//TODO BIDON - to remove voici comment afficher la versionVersion : abcx :  {{ appVersion }}-->
